import React from "react";
import { LayoutGrid, Wrench, Columns2 } from "lucide-react";

const CATEGORIES = [
  { value: "boards", label: "Boards", icon: LayoutGrid, hint: "Gypsum boards catalogue" },
  { value: "accessories", label: "Accessories", icon: Wrench, hint: "Metal accessories & insulation" },
  { value: "drywall-metal-frame", label: "Drywall frames", icon: Columns2, hint: "Drywall metal frame products" },
  { value: "ceiling-metal-frame", label: "Ceiling frames", icon: Columns2, hint: "Ceiling metal frame products" },
];

const ProductsCategoryTabs = ({ value, onChange }) => (
  <div className="dashboard-h-scroll flex gap-2 overflow-x-auto pb-2.5 -mx-1 px-1 sm:grid sm:grid-cols-2 sm:overflow-visible sm:pb-0 sm:mx-0 sm:px-0">
    {CATEGORIES.map(({ value: id, label, icon: Icon, hint }) => {
      const selected = value === id;
      return (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          className={`products-category-tab shrink-0 w-[min(100%,280px)] sm:w-full text-left rounded-xl border-2 p-4 transition box-border ${
            selected
              ? "border-white bg-white text-[#0b1f3f] shadow-sm"
              : "border-white/20 bg-white/10 text-white hover:bg-white/20"
          }`}
          aria-pressed={selected}
        >
          <div className="flex items-center gap-3 min-h-[2.5rem]">
            <span
              className={`shrink-0 flex h-10 w-10 items-center justify-center rounded-lg ${
                selected ? "bg-[#0b1f3f] text-white" : "bg-white/15 text-white"
              }`}
            >
              <Icon size={20} aria-hidden />
            </span>
            <span className="min-w-0 flex-1">
              <span className={`block font-semibold leading-snug ${selected ? "text-[#0b1f3f]" : "text-white"}`}>
                {label}
              </span>
              <span
                className={`block text-sm mt-0.5 leading-snug ${selected ? "text-slate-500" : "text-white/70"}`}
              >
                {hint}
              </span>
            </span>
          </div>
        </button>
      );
    })}
  </div>
);

export default ProductsCategoryTabs;
